import React from 'react';
import MypagAsListWrapper from 'components/MypagAsListWrapper/MypagAsListWrapper';

export default function MypagAsListContainer() {
    return (
        <MypagAsListWrapper />
    )
}
